import { Auth } from 'aws-amplify';
import axios from 'axios';

const catchError = (e) => {
  if (e.response) {
    return e.response.data.message;
  }
  return e.message;
};

export const initiateFuzzyMatch = async (data) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return axios
    .post(`${process.env.REACT_APP_FUZZY_MATCH_API_URL}/fuzzy-match/initiate`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-selected-organization': localStorage.getItem('organization-context'),
      },
    })
    .catch((e) => {
      const error = catchError(e);
      throw new Error(error);
    });
};

export const uploadFuzzyMatchFile = async (formData) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return axios
    .post(
      `${process.env.REACT_APP_FUZZY_MATCH_API_URL}/fuzzy-match/upload-file`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
          'x-selected-organization': localStorage.getItem('organization-context'),
        },
      }
    )
    .catch((e) => {
      const error = catchError(e);
      throw new Error(error);
    });
};

export const generatePresignedUrl = async (data) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return axios
    .post(
      `${process.env.REACT_APP_FUZZY_MATCH_API_URL}/fuzzy-match/presigned-url`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'x-selected-organization': localStorage.getItem('organization-context'),
        },
      }
    )
    .catch((e) => {
      const error = catchError(e);
      throw new Error(error);
    });
};

export const uploadFileToS3 = async (presignedUrl, file) => {
  return axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      return percentCompleted;
    },
  });
};

export const processUploadedFile = async (data) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return axios
    .post(
      `${process.env.REACT_APP_FUZZY_MATCH_API_URL}/fuzzy-match/process-file`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'x-selected-organization': localStorage.getItem('organization-context'),
        },
      }
    )
    .catch((e) => {
      const error = catchError(e);
      throw new Error(error);
    });
};

export const fetchFuzzyMatchStatus = async (fuzzyMatchRequestId) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return axios.post(
    `${process.env.REACT_APP_FUZZY_MATCH_API_URL}/fuzzy-match/status`,
    {
      fuzzyMatchRequestId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-selected-organization': localStorage.getItem('organization-context'),
      },
    }
  );
};

export const finalizeFuzzyMatchUpload = async (fuzzyMatchRequestId) => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return axios.post(
    `${process.env.REACT_APP_FUZZY_MATCH_API_URL}/fuzzy-match/finalize-upload`,
    { fuzzyMatchRequestId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-selected-organization': localStorage.getItem('organization-context'),
      },
    }
  );
};
